module.exports = __webpack_public_path__ + "static/media/notFound.9fa96966.svg";